/**
 * FileAction 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileAction
 */
export interface FileAction {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 关联 file_info.id */
  file_id?: string
  /** 执行操作的用户ID */
  user_id?: string
  /** 用户执行的操作类型 */
  action_type?: string
  /** 行为的详细数据，根据不同行为类型存储不同信息：         播放: {"progress": 0.8, "duration": 120, "position": 96}         分享: {"platform": "wechat", "target": "moments"}         下载: {"speed": 1024000, "time_cost": 10}         查看: {"duration": 30, "scroll_depth": 0.6}         放大: {"zoom_level": 2.5, "area": {"x": 100, "y": 200}} */
  action_data?: string
  /** 行为来源，如：feed/search/share/recommend */
  source?: string
  /** 设备类型，如：ios/android/web/pc */
  device_type?: string
  /** 用户的IP地址 */
  ip_address?: string
  /** 浏览器或客户端的User Agent */
  user_agent?: string
}

/**
 * FileAction Schema
 */
export const FileActionSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    file_id: {
      description: '关联 file_info.id',
      format: 'string',
      type: 'string',
      label: '关联',
    },
    user_id: {
      description: '执行操作的用户ID',
      format: 'string',
      type: 'string',
      label: '执行操作的用户ID',
    },
    action_type: {
      description: '用户执行的操作类型',
      format: 'cons.FileActionType',
      type: 'string',
      label: '用户执行的操作类型',
    },
    action_data: {
      description:
        '行为的详细数据，根据不同行为类型存储不同信息：         播放: {"progress": 0.8, "duration": 120, "position": 96}         分享: {"platform": "wechat", "target": "moments"}         下载: {"speed": 1024000, "time_cost": 10}         查看: {"duration": 30, "scroll_depth": 0.6}         放大: {"zoom_level": 2.5, "area": {"x": 100, "y": 200}}',
      format: 'string',
      type: 'string',
      label: '行为的详细数据',
    },
    source: {
      description: '行为来源，如：feed/search/share/recommend',
      format: 'string',
      type: 'string',
      label: '行为来源',
    },
    device_type: {
      description: '设备类型，如：ios/android/web/pc',
      format: 'string',
      type: 'string',
      label: '设备类型',
    },
    ip_address: {
      description: '用户的IP地址',
      format: 'string',
      type: 'string',
      label: '用户的IP地址',
    },
    user_agent: {
      description: '浏览器或客户端的User Agent',
      format: 'string',
      type: 'string',
      label: '浏览器或客户端的User',
    },
  },
  type: 'object',
}
